import { BaseService } from "./BaseService";

export const RepasseService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('repasse/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos repasses:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`repasse/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de repasses:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('repasse/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir repasses:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('repasse/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar repasses:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('repasse/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar repasses:', error);
            return false;
        }
    }, 
}